import { RootState } from "../lib/redux/store";

export const daysOptions = (options: any) => [
  { value: 7, label: options.all_days },
  { value: 0, label: options.monday },
  { value: 1, label: options.tuesday },
  { value: 2, label: options.wednesday },
  { value: 3, label: options.Thursday },
  { value: 4, label: options.Friday },
  { value: 5, label: options.Saturday },
  { value: 6, label: options.Sunday },
];

export const daysOptions2 = (options: any) => [
  { value: "Mon", label: options.monday },
  { value: "Tue", label: options.tuesday },
  { value: "Wed", label: options.wednesday },
  { value: "Thu", label: options.Thursday },
  { value: "Fri", label: options.Friday },
  { value: "Sat", label: options.Saturday },
  { value: "Sun", label: options.Sunday },
];
export const daysOptions3 = (options: any) => [
  { value: "Monday", label: options.monday },
  { value: "Tuesday", label: options.tuesday },
  { value: "Wednesday", label: options.wednesday },
  { value: "Thursday", label: options.Thursday },
  { value: "Friday", label: options.Friday },
  { value: "Saturday", label: options.Saturday },
  { value: "Sunday", label: options.Sunday },
];

export const courtTypeOptions = (options: any) => [
  { value: "indoor", label: options.indoor },
  { value: "outdoor", label: options.outdoor },
  { value: "roofed", label: options.roofed },
];

export const coachgender = (options: any) => [
  { value: "Male", label: options.male },
  { value: "Female", label: options.female },
];

export const playersGender = (options: any) => [
  { value: "Male", label: options.male },
  { value: "Female", label: options.female },
  { value: "Both", label: options.both },
];

export const tableRowsNumber = [
  { value: "10", label: "10" },
  { value: "25", label: "25" },
  { value: "50", label: "50" },
  { value: "100", label: "100" },
];
export const slotOption = [
  { slot: "30" },
  { slot: "45" },
  { slot: "60" },
  { slot: "90" },
  { slot: "120" },
  { slot: "150" },
  { slot: "180" },
];
export const courtSize = (options: any) => [
  { value: "Double", label: options.double },
  { value: "Normal", label: options.single },
];

export const courtPrivacy = (options: any) => [
  { value: "private", label: options.private },
  { value: "public", label: options.public },
];

export const profileGenderOptions = (options: any) => [
  { value: "male", label: options.male },
  { value: "female", label: options.female },
  { value: "both", label: options.both },
];

export const leagTourStatusOptions = (options: any) => [
  { value: "Pending", label: options.Pending },
  { value: "Finished", label: options.finished },
  { value: "In Process", label: options.in_process },
  { value: "Confirmed", label: options.confirmed },
  { value: "Canceled", label: options.canceled },
];

export const leagTourGenderOptions = (options: any) => [
  { value: "Male", label: options.male },
  { value: "Female", label: options.female },
  { value: "Mixed", label: options.mixed },
];

export const joiningTypeOptions = (options: any) => [
  { value: "Single", label: options.single },
  { value: "Double", label: options.double },
];

export const joiningFromOptions = (options: any) => [
  { value: "Club", label: options.club },
  { value: "App", label: options.app },
];

export const eventTypeOptions = (options: any) => [
  { value: "King of the Courts", label: options.king_of_the_courts },
  { value: "Americano", label: options.americano },
  { value: "Mexicano", label: options.mexicano },
];

export const eventPlayersPaymentStatusOptions = (options: any) => [
  { value: "Pending", label: options.Pending },
  { value: "Paid", label: options.paid },
];

export const TournamentTypeOptions = (options: any) => [
  { value: "Knockouts", label: options.knockouts },
  { value: "Round Robin", label: options.round_robin },
];
